import type { AxiosRequestConfig } from "axios";

import { getLocale } from "../shared/language";

export const LOCALIZATION_HEADER = "Accept-Language";
export const Culture_HEADER = "X-Culture";

export function addLocalizationHeader<T extends AxiosRequestConfig>(
  config: T,
): T {
  config.headers = config.headers || {};
  config.headers[LOCALIZATION_HEADER] = getLocale();
   config.headers[Culture_HEADER] = getLocale();
  return config;
}
